/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component } from '@angular/core';

@Component({
    selector: 'ui-label',
    template: require('./ui-label.html'),
    styles: [require('./ui-label.less')]
})



export class UiLabel {}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-label/ui-label.ts